/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState, useEffect } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "./../../../../apiClient";

function AddPolice({ onClose, onSuccess, editFormData }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [state, setState] = useState([]);
  const [district, setDistrict] = useState([]);
  const [city, setCity] = useState([]);
  const [editData, setEditData] = useState(editFormData);

  const [formData, setFormData] = useState({
    station_name: editData?.station_name || "",
    user_id: editData?.user_id || "",
    password: editData?.password || "",
    phone: editData?.phone || "",
    state: editData?.state || "",
    district: editData?.district || "",
    city: editData?.city || "",
    address: editData?.address || "",
  });

  useEffect(() => {
    getState();
  }, []);

  const getState = async () => {
    const response = await apiClient.get("/admin/state");
    if (response.status === 200) {
      const sortedStates = response.data.sort((a, b) => a.name.localeCompare(b.name));
      setState(sortedStates);
    }
  };

  const getDistrict = async (value) => {
    const response = state && (await apiClient.get(`/admin/district/state/${value}`));
    if (response.status === 200) {
      const sortedDistrict = response.data.sort((a, b) => a.name.localeCompare(b.name));
      setDistrict(sortedDistrict);
    }
  };

  const getCity = async (value) => {
    const response = await apiClient.get(`/admin/cites/district/${value}`);
    if (response.status === 200) {
      const sortedCity = response.data.sort((a, b) => a.name.localeCompare(b.name));
      setCity(sortedCity);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "state") {
      console.log("State:", value);
      let stateID = value && state.find((item) => item.name === value)._id;
      value && getDistrict(stateID);
    }
    if (name === "district") {
      let districtID = value && district.find((item) => item.name === value)._id;
      value && getCity(districtID);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    const isEdit = editData && Object.keys(editData).length > 0; // Check if editData exists
    try {
      console.log("Form data submitted:", formData);
      const endpoint = isEdit ? `/admin/policestation/${editData._id}` : "/admin/policestation";
      const method = isEdit ? "put" : "post";
      const response = await apiClient[method](endpoint, formData);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else {
          console.error("Error in response:", response.data);
        }
      }
    } catch (error) {
      console.error(
        isEdit ? "Error updating policestation:" : "Error creating policestation:",
        error
      );
    }
  };

  return (
    <Card id="add-poilce">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Station"
                name="station_name"
                value={formData.station_name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="User ID"
                name="user_id"
                value={formData.user_id}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Phone"
                name="phone"
                type="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">State</InputLabel>
                <Select
                  label="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MenuItem value="">
                    <em>Select State</em>
                  </MenuItem>
                  {state &&
                    state.length > 0 &&
                    state.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">District</InputLabel>
                <Select
                  label="District"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MenuItem value="">
                    <em>Select District</em>
                  </MenuItem>
                  {district &&
                    district.length > 0 &&
                    district.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">City</InputLabel>
                <Select
                  label="City"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MenuItem value="">
                    <em>Select City</em>
                  </MenuItem>
                  {city &&
                    city.length > 0 &&
                    city.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
                multiline
                rows={4}
              />
            </Grid>
            <Grid item xs={8}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default AddPolice;
